<template>
  <div id="app">
    <div id="header" v-if="!isInApp">
      <div class="container">
        <a href="https://www.jdcloud.com/">
          <template v-if="!isEN"
            ><img class="logo" src="https://menu.s3.cn-north-1.jdcloud-oss.com/logo_cn_b_t.png"
          /></template>
          <template v-else
            ><img class="logo" src="https://menu.s3.cn-north-1.jdcloud-oss.com/logo_en_b_t.png"
          /></template>
        </a>
        <h1 class="title">{{ $t(title) }}</h1>
        <div class="gotoLogin" v-if="showLogin">
          <span class="i18n-text">{{ $t('已有账号？') }}</span
          ><a class="i18n-text" :href="`//login.jdcloud.com?returnUrl=${getReturnUrl()}`">{{
            $t('去登录')
          }}</a>
        </div>
        <!-- <div class="switchLang">
                <span :class="['lang-option','cn', {'current-option':!isEN}]" @click="changeLang('cn')">中文</span>/<span :class="['lang-option','cn', {'current-option':isEN}]" @click="changeLang('en')">En</span>
              </div> -->
      </div>
    </div>
    <router-view />
    <div id="footer" v-if="!isInApp">
      <div class="container">
        <div class="copyright">
          Copyright©2012-2024 JDCloud.com
          <span
            >{{ $t('版权所有 ')
            }}<a href="http://beian.miit.gov.cn">{{ $t('京ICP备11041704号-31') }}</a
            >{{ $t(' 京ICP证070359号') }}</span
          >
        </div>
        <div class="linkbar">
          <a
            href="https://docs.jdcloud.com/platform-agreement/privacy-policy"
            target="_blank"
            class="i18n-text"
            >{{ $t('隐私声明') }}</a
          >
          <a
            href="https://img1.jcloudcs.com/portal/service/business_license.png"
            target="_blank"
            class="i18n-text"
            >{{ $t('资质证照') }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import getTranslation from '@/i18n/getTranslation'
import getReturnUrl from '@/mixins/getReturnUrl-mixins'
export default {
  mixins: [getReturnUrl],
  data() {
    let jdcloud_sitelang = this.getCookies('jdcloud_sitelang')
    return {
      isEN: jdcloud_sitelang === 'en' || this.$route.query.source === 'jdcloud-en_US',
      jdcloud_sitelang: jdcloud_sitelang,
      title: '',
      showLogin: true,
      isForPwd: true,
      isChangePwd: false,
      isBind: false,
      isInApp: false,
      isRegistry: false,
      isShow: false,
      link_618: '//www.jdcloud.com/cn/activity/618'
    }
  },
  watch: {
    isInApp(val) {
      if (val) {
        // eslint-disable-next-line
        $('body').css('background', 'none');
      }
    }
  },
  components: {},
  created() {},
  mounted() {
    this.setData()
    window.isEN = this.isEN
    this.isJdcloudAPP()
  },
  methods: {
    delCookie(name) {
      Cookies.remove(name)
    },
    getCookies(name) {
      return Cookies.get(name)
    },
    setCookie(name, value) {
      Cookies.set(encodeURIComponent(name), encodeURIComponent(value), {
        expires: 7,
        domain: '.jdcloud.com'
      })
      Cookies.set(encodeURIComponent(name), encodeURIComponent(value), {
        expires: 7,
        domain: '.jcloud.com'
      })
    },
    changeLang(lang) {
      if (lang === this.getCookies('jdcloud_sitelang')) {
        return false
      }
      this.delCookie('jdcloud_sitelang')
      this.setCookie('jdcloud_sitelang', lang)
      window.location.reload()
    },
    setData() {
      //根据url修改title
      if (this.$route.path === '/register') {
        this.isRegistry = true
        this.isForPwd = false
        this.isChangePwd = false
      } else if (this.$route.query.p) {
        this.isChangePwd = true
        this.isForPwd = false
      } else if (['bind-account', 'bindResult'].includes(this.$route.name)) {
        this.isBind = true
        this.isForPwd = false
      } else {
        this.isChangePwd = false
        this.isForPwd = true
      }
      this.setTitle()
    },
    setTitle() {
      document.title = this.isChangePwd
        ? getTranslation('修改密码')
        : this.isForPwd && this.$route.path !== '/registerSuccess'
        ? getTranslation('忘记密码')
        : getTranslation('账号注册')
      if (this.isChangePwd) {
        document.title = '安全验证中心'
        this.title = '安全验证中心'
        this.showLogin = false
      } else if (this.isForPwd) {
        this.title = ''
        this.showLogin = false
      } else if (this.isBind) {
        document.title = getTranslation('绑定京东云账号')
        // this.title = '联合登录'
        this.showLogin = false
      } else {
        this.showLogin = true
        this.title = '注册'
      }
    },
    isJdcloudAPP() {
      setTimeout(async () => {
        let userAgent = window.navigator.userAgent
        if (userAgent.indexOf('JDCLOUD-APP') !== -1) {
          this.isInApp = true
        } else {
          this.isInApp = false
        }
        window.isInApp = this.isInApp
        this.isShow = true
      }, 500)
    },
    close() {
      this.isShow = false
    }
  }
}
</script>

<style lang="less">
@brand-color: rgba(225, 37, 27, 1);
.copyright a {
  font-size: 12px;
  color: #4a4a4a;
}
.copyright a:hover {
  color: #4a90e2;
  text-decoration: none;
}
.el-button--danger {
  background-color: @brand-color !important;
  border-color: @brand-color !important;
}
.confirmButtonClass {
  background-color: @brand-color !important;
  border-color: @brand-color !important;
}
.cancelButtonClass {
  &:hover {
    color: @brand-color;
  }
}
.el-button:focus,
.el-button:hover {
  border-color: @brand-color !important;
}
.el-radio__inner {
  width: 18px;
  height: 18px;
  vertical-align: super;
}
.el-radio__input.is-checked .jc-radio__inner {
  width: 18px;
  height: 18px;
  border-color: @brand-color !important;
}
.el-radio__inner::after {
  width: 10px;
  height: 10px;
  background-color: @brand-color !important;
}
.el-checkbox__inner:hover {
  border-color: @brand-color !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: @brand-color !important;
  border-color: @brand-color !important;
}
</style>
